import React from "react";

import RevenuesCard from "./RevenuesCard";
import ExpenseCard from "./ExpenseCard";
import SummaryReport from "./SummaryReport";
import ExpensesChart from "./ExpensesChart";
import RevenuesChart from "./RevenuesChart";

const GeneralReport = (props) => {
  const { generalData } = props;

  return generalData ? (
    <div className="box-wrapper flex">
      <div className="finance-chart-wrapper">
        <SummaryReport data={generalData} />
        <ExpensesChart data={generalData} />
        <RevenuesChart data={generalData} />
      </div>
      <div className="finance-table-wrapper">
        <RevenuesCard data={generalData} />
        <ExpenseCard data={generalData} />
      </div>
    </div>
  ) : null;
};

export default GeneralReport;
